interface FAQItem {
    titulo: string;
    subTitulo: string | { __html: string };
}

interface PreguntasFrecuentesProps {
    faqs: FAQItem[];// Cambia a un array de objetos FAQItem
    paddingY?: number;
    tituloClassName?: string;
}

const TITULO_CLASS_NAME_DEFAULT = "ff-mukta fw-bold fs-30 fs-lg-40 text-black text-center mb-5";

export const PreguntasFrecuentes = ({ faqs, paddingY = 5, tituloClassName = TITULO_CLASS_NAME_DEFAULT }: PreguntasFrecuentesProps) => {



    return (
        <div className={`py-${paddingY} bg-f4`}>
            <div className="container">
                <h2 className={tituloClassName}>
                    Preguntas Frecuentes
                </h2>
                <div className="px-3 py-2 bg-white rounded-10 mb-5">
                    <div className="accordion accordion-flush accordion-faq" id="faqAccordion">
                        {faqs.map((faq, index) => (
                            <div className="accordion-item" key={index}>
                                <h3 className="accordion-header">
                                    <button
                                        className="accordion-button collapsed"
                                        type="button"
                                        data-bs-toggle="collapse"
                                        data-bs-target={`#collapse${index}`}
                                        aria-expanded="false"
                                        aria-controls={`collapse${index}`}
                                    >
                                        {faq.titulo}
                                    </button>
                                </h3>
                                <div
                                    id={`collapse${index}`}
                                    className="accordion-collapse collapse"
                                    data-bs-parent="#faqAccordion"
                                >
                                    <div className="accordion-body">
                                        <p className="fs-15 fs-lg-16 lh-16 mb-20">
                                            {typeof faq.subTitulo === 'string' ? (
                                                faq.subTitulo
                                            ) : (
                                                <span dangerouslySetInnerHTML={faq.subTitulo} />
                                            )}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    )
}
